import React, { useEffect } from "react";

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    margin: 0,
    padding: 0,
    overflow: "hidden",
  },
  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
  },
};

export const Contract = () => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div style={styles.container}>
      <iframe
        src="https://peace-payroll-bucket.s3.eu-north-1.amazonaws.com/pce.html"
        title="Contract"
        style={styles.iframe}
      />
    </div>
  );
};
